import React from "react";
import { FormGroup, Label, Input } from "reactstrap";

const CheckBox = ({
  checked,
  setChecked,
  containerClass,
  inputClass,
  labelClass,
  labelText,
  disabled = false,
}) => {
  return (
    <FormGroup check inline className={containerClass}>
      <Input
        type="checkbox"
        id="remember"
        checked={checked}
        onClick={() => {
          setChecked(!checked);
        }}
        className={inputClass}
        disabled={disabled}
      />
      <Label
        check
        className={`mb-0 custom-check-box ${labelClass} ${
          disabled ? "text-muted" : ""
        }`}
        htmlFor="remember"
      >
        {labelText}
      </Label>
    </FormGroup>
  );
};

export default CheckBox;
